"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var core_utilities_1 = require("@syl-editor/core-utilities");
var nodeview_1 = require("./nodeview");
var utils_1 = require("./utils");
// 在code标签中插入换行
var formatCodeDOMStructure = function (dom) {
    var codeTags = Array.prototype.slice.call(dom.querySelectorAll('code'));
    var spans = Array.prototype.slice.call(dom.querySelectorAll('span'));
    codeTags.forEach(function (code, idx) {
        if (idx === codeTags.length - 1)
            return;
        code.appendChild(document.createElement('br'));
    });
    spans.forEach(function (span) {
        if (/\u200B/.test(span.innerText)) {
            span.innerText = span.innerText.replace(/\u200B/g, '');
        }
    });
};
var arrowHandler = function (dir) { return function (editor, state, dispatch, view) {
    if (state.selection.empty && view.endOfTextblock(dir)) {
        var side = dir === 'left' || dir === 'up' ? -1 : 1;
        var $head = state.selection.$head;
        var nextPos = prosemirror_state_1.Selection.near(state.doc.resolve(side > 0 ? $head.after() : $head.before()), side);
        if (nextPos.$head && nextPos.$head.parent.type.name === 'code_block') {
            dispatch(state.tr.setSelection(nextPos));
            return true;
        }
    }
    return false;
}; };
var CodeBlock = /** @class */ (function (_super) {
    __extends(CodeBlock, _super);
    function CodeBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'code_block';
        _this.tagName = function () { return 'pre'; };
        _this.code = true;
        _this.notLastLine = true;
        _this.marks = '';
        _this.attrs = {
            language: {
                default: utils_1.DEFAULT_LANGUAGE
            }
        };
        _this.textMatcher = [
            {
                matcher: /^```([^\s]*)\s$/,
                handler: function (match) {
                    return {
                        language: utils_1.transformToShow(match[1])
                    };
                }
            },
            {
                matcher: /^```([^\s]*)$/,
                timing: 'enter',
                handler: function (match) {
                    return {
                        language: utils_1.transformToShow(match[1])
                    };
                }
            }
        ];
        _this.content = 'text*';
        _this.parseDOM = [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    var parentElement = dom.parentElement;
                    if (!parentElement || !parentElement.classList.contains('code-snippet__js')) {
                        formatCodeDOMStructure(dom);
                    }
                    if (dom.querySelector('.ace-line')) {
                        // doc每一行都会插一个br，会导致最后一行多个一br
                        var lastBr = Array.prototype.slice.call(dom.querySelectorAll('br')).pop();
                        if (lastBr && lastBr.parentElement) {
                            lastBr.parentElement.removeChild(lastBr);
                        }
                    }
                    // 去除最后一行无必要的换行（jianshu）
                    var lineDOM = dom.querySelector('.line-numbers-rows');
                    if (lineDOM &&
                        lineDOM.previousSibling &&
                        lineDOM.previousSibling.textContent === '\n' &&
                        lineDOM.parentElement) {
                        lineDOM.parentElement.removeChild(lineDOM.previousSibling);
                    }
                    return getAttrs(dom);
                }
            },
            {
                tag: 'div.CodeMirror',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    // 结构为<div><pre></pre></div>, .CodeMirror-linenumber为序号，pre为一行
                    var preTags = Array.prototype.slice.call(dom.querySelectorAll('pre'));
                    var orderDOMs = Array.prototype.slice.call(dom.querySelectorAll('.CodeMirror-linenumber'));
                    preTags.forEach(function (pre, idx) {
                        if (idx === preTags.length - 1)
                            return;
                        pre.appendChild(document.createTextNode('br'));
                    });
                    orderDOMs.forEach(function (_dom) {
                        if (_dom.parentElement) {
                            _dom.parentElement.removeChild(_dom);
                        }
                    });
                    return getAttrs(dom);
                }
            },
            {
                tag: 'p[code_block]',
                preserveWhitespace: 'full',
                getAttrs: getAttrs
            },
            {
                tag: 'section.code-snippet__js',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    // 结构为 <section><ul></ul><pre><code></code></pre></section>, ul为序号，code为一行
                    var preDOM = dom.querySelector('pre');
                    if (!preDOM)
                        return false;
                    var orderDOM = dom.querySelector('ul');
                    if (orderDOM)
                        dom.removeChild(orderDOM);
                    formatCodeDOMStructure(dom);
                    return getAttrs(preDOM);
                }
            }
        ];
        _this.defining = true;
        _this.toDOM = function (node) {
            return ['pre', { language: node.attrs.language, code_block: true }, ['code', 0]];
        };
        return _this;
    }
    CodeBlock.keymap = {
        ArrowLeft: arrowHandler('left'),
        ArrowRight: arrowHandler('right'),
        ArrowUp: arrowHandler('up'),
        ArrowDown: arrowHandler('down')
    };
    CodeBlock.NodeView = nodeview_1.CodeBlockView;
    return CodeBlock;
}(core_utilities_1.Block));
exports.CodeBlock = CodeBlock;
function getAttrs(dom) {
    var language = dom.getAttribute('language');
    if (!language) {
        var wrapper = dom.querySelector('[language]');
        language = (wrapper && wrapper.getAttribute('language')) || utils_1.DEFAULT_LANGUAGE;
    }
    return {
        language: utils_1.transformToShow(language)
    };
}
//# sourceMappingURL=schema.js.map